import {useEffect} from 'react'
import {FAQMainBox, FAQStyledBox, FAQStyledTypography} from './FaqStyles'
import {Divider, styled} from '@mui/material'
import CustomBox from '../common/CustomBox'
import FaqAccordion from './FaqAccordion'
import {useTheme} from '@mui/material/styles'
import PropTypes from 'prop-types'
import {useAnalyticsPageLoad} from '../../hooks/useAnalyticsPageLoad'
import GlobalNoteComponent from './GlobalNoteComponent'
import {getPrismProgram} from '../../shared/helpers/common'

const FaqApp = ({setIsFAQopen}) => {
  const theme = useTheme()
  const prismProgram = getPrismProgram()
  useEffect(() => {
    setIsFAQopen(true)
  })

  useAnalyticsPageLoad('FAQs')

  const StyledDescription = styled(CustomBox)(() => ({
    fontSize: theme.typography.h6.fontSize
  }))

  return (
    <FAQMainBox component='main'>
      <FAQStyledBox sx={{height: 'auto'}}>
        <FAQStyledTypography tabIndex={0} aria-label='FAQ home page' title={'faq'}>
          Frequently Asked Questions
        </FAQStyledTypography>
        <Divider
          sx={{
            width: '67px',
            border: `3px solid ${theme.palette.hpAccentYellowGreen}`,
            float: 'left',
            marginTop: '10px'
          }}
          title={'Frequently Asked Questions'}
        />
        <br />
        <GlobalNoteComponent />
        <br />
        <StyledDescription sx={{color: theme.palette.hpAccentBlack}} tabIndex={0}>
          Below are frequently asked questions from {prismProgram} users. If you still can’t find an answer to your
          question, send us an email at{' '}
          <a
            style={{color: theme.palette.hpPrimaryDark}}
            href='https://deloittesupportportal.service-now.com/csm'
            target='_blank'
            rel='noopener noreferrer'
          >
            Customer Support
          </a>
        </StyledDescription>
        <FaqAccordion />
      </FAQStyledBox>
    </FAQMainBox>
  )
}

FaqApp.propTypes = {
  setIsFAQopen: PropTypes.func
}

export default FaqApp
